<template>
    <!-- Modal Detail User -->    
    <CModal
    title="Modal title"    
    :show.sync="modalDetailPelatihanOnline"
    :no-close-on-backdrop="true"
    :closeOnBackdrop="false"
    :centered="true"        
    >
    <CRow>
        <div class="modal-body row my-n3">            
            <div class="col-12">
                <center class="mb-2">
                    <img :src="formData.thumbnail" alt="" srcset="">
                </center>
                <table class="table w-100">
                    <tr>
                        <td class="border-0">Nama Pelatihan</td>
                        <td class="border-0">:</td>
                        <td class="border-0">  </td>
                    </tr>
                    <tr>
                        <td>Deskripsi</td>
                        <td>:</td>
                        <td>  </td>
                    </tr>
                    <tr>
                        <td>Penyelenggara</td>
                        <td>:</td>
                        <td> </td>
                    </tr>
                </table>
            </div>
        </div>
    </CRow>
    <template #header>
        <h6 class="modal-title h5 font-weight-bold">Detail Webinar</h6>
    </template>
    <template #footer>
        <CButton @click="tutupModal" color="danger">Tutup</CButton>
    </template>
    </CModal>
    <!-- End Modal -->
</template>
<script>
import UtilsService from "../../../services/utils.service"
import WorkshopService from "../../../services/pelatihan/workshop.service";
import BaseUrl from "../../../services/base-url";

export default {
    name: 'Modal',
    data() {
        return {
            lihat_foto : '',
            detailData : {
                namaPelatihan : '',
                deskripsiPelatihan : "",
                penyelenggara : ''
            },
            baseUrl: ''
        }
    },
    components : {
    },
    props: [
        'modalDetailPelatihanOnline',
        'title',
        'formData'
    ],
    mounted() {
        this.baseUrl = BaseUrl();
        this.getDetail(this.formData.id_workshop_pelatihan);
    },
    methods : {
        getDetail(id_workshop_pelatihan) {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel,
            });
            
            var vm = this;
            WorkshopService.getDetailWorkshop(id_workshop_pelatihan)
            .then(response => {
                this.detailData = response.data.singleData
                let routeData =
                this.baseUrl +
                "/files?filename=" +
                response.data.singleData.flyer +
                "&path=pelatihan@flyer";
                this.lihat_foto = routeData

                // if(response.data.singleData.pelatihanDokumen <= 0)
                // {
                // // comment console console.log("DOKUMEN KOSONG")
                // vm.detailData.pelatihanDokumen = [
                //     {
                //     contoh_dokumen: "",
                //     kode_dokumen: "",
                //     nama_dokumen: "",
                //     idDokumenPendukung : "",
                //     fileName: "",
                //     idMasterDokumen: "",
                //     invalid_dokumen: false,
                //     modelMultiSelect: [],
                //     },
                // ];
                // }
                // this.detailData.deletePelatihanInstrukturRequest = [];
                // this.detailData.deletePelatihanModeratorRequest = [];
                // this.detailData.deletePelatihanKatalogRequest = []
                // this.detailData.deletePelatihanDokumenRequest = [];
                // this.detailData.deletePengaturanAssessmentRequest = [];
                // this.detailData.deletePelatihanMateriRequest = []
                // this.detailData.deleteJadwalPelatihanRequest = []

                loader.hide()
            }).catch(error => {
                // comment console console.log(error);
                loader.hide()

            })
        },
        tutupModal() {
            this.$parent.tutupModal();
        }
    },
    computed: {
      
    }
}
</script>